import moment from 'moment';

export default function ConfirmCompleteAssessmentDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ssDialogService,
  loaderService,
  ecatSharedModelService,
  ecatDataService,
  reportsDataService,
) {
  const vm = this;

  vm.handleCloseDialog = _closeCompleteDialog;

  vm.handleConfirmCompleteAssessment = _confirmCompleteAssessment;
  vm.handleCloseDialog = _handleCloseDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
    vm.completedById = -1;
    vm.completedCurrentDate = moment().add(0, 'days');
    vm.completedDate = vm.completedCurrentDate.format('MM/DD/YYYY');
  }

  function _confirmCompleteAssessment() {
    loaderService.showViewLoader = true;
    const assessmentId = vm.assessmentId;
    const completedById = vm.completedById;
    const completedDate = vm.completedCurrentDate.format('MM/DD/YYYY');
    return ecatDataService
      .completeAssessment(assessmentId, completedById, completedDate)
      .then(response => {
        if (!response.data.result) {
          alerts.error('An Error occurred while saving the Assessment.');
        } else {
          alerts.success('The Assessment has been completed successfully.');
          alerts.info('Please Wait! Updating the ECAT Assessment Document. This may take a while');
          _generateDocumentAndDownload();
          _closeCompleteDialog();
        }
      })
      .catch(() => {
        alerts.error('An Error occurred while completing the Assessment.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCloseDialog() {
    _closeCompleteDialog();
  }

  function _closeCompleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.completeAssessmentConfirmDialog);
  }

  function _generateDocumentAndDownload() {
    loaderService.showViewLoader = true;

    let reportSections = '1,2';

    if (vm.templateId === 2) {
      reportSections = '3';
    }

    ecatDataService
      .generateFullReport(
        {
          assessmentId: vm.assessmentId,
          name: vm.assessmentName,
          renderFullReport: true,
          reportSection: reportSections,
          saveDocument: true,
        },
        '',
      )
      .then(response => {
        loaderService.showViewLoader = false;
        alerts.success('The ECAT Assessment Document is updated successfully.');
        $rootScope.$broadcast('refreshECATAssessments');
        reportsDataService.download(response);
      });
  }
}

ConfirmCompleteAssessmentDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ssDialogService',
  'loaderService',
  'ecatSharedModelService',
  'ecatDataService',
  'reportsDataService',
];
